const download = (url) => {
	window.open(url)
}

export {
	download
}
